import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"
import { apiUrl, getByAxios } from "../helpers/axios.js"
import { currentLocation } from "../helpers/location.js"

export default class extends Controller {
  initialize () {
    // Is run first. In this case we don't need to worry about anything.
  }

  connect() {
    let realtimeAlertController = this;

    this.subscription = consumer.subscriptions.create(
      {
        channel: "RealtimeAlertChannel"
      },
      {
        connected() {
          // Called when the subscription is ready for use on the server
        },
        disconnected() {
          // Called when the subscription has been terminated by the server
        },
        received(data) {
          realtimeAlertController.renderAlert(data);
        }
      }
    );
  }

  disconnect() {
    this.subscription.unsubscribe();
  }

  renderAlert(data) {
    $(document).Toasts('create', {
      autohide: true,
      position: 'bottomLeft',
      delay: 5000,
      title: data['title'],
      body: data['message'],
      class: `bg-${data['type'].replace('alert','warning').replace('error','danger').replace('notice','success')}`
    })
  }
}
